var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg019Connection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99994 21C8.73414 21.0015 8.47866 20.8972 8.28994 20.71L4.28994 16.71C3.89782 16.3179 3.89782 15.6821 4.28994 15.29C4.68206 14.8979 5.31782 14.8979 5.70994 15.29L7.99994 17.59V4C7.99994 3.44772 8.44766 3 8.99994 3C9.55223 3 9.99994 3.44772 9.99994 4V20C9.99793 20.4037 9.75337 20.7666 9.37994 20.92C9.26126 20.976 9.13112 21.0034 8.99994 21ZM15.9999 20C15.9999 20.5523 15.5522 21 14.9999 21C14.4477 21 13.9999 20.5523 13.9999 20V4C14.002 3.5963 14.2465 3.2334 14.6199 3.08C14.9923 2.9234 15.4224 3.00626 15.7099 3.29L19.7099 7.29C20.1021 7.68212 20.1021 8.31788 19.7099 8.71C19.3178 9.10212 18.6821 9.10212 18.2899 8.71L15.9999 6.41V20Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg019Connection);
export default __webpack_public_path__ + "static/media/019-connection.5d87a3a40b72502a7e200c5424d4dcb7.svg";
export { ForwardRef as ReactComponent };